import { InfoAlert } from 'components/alerts';
import { Link, Text } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import '../style.scss';

export default function ProviderInactive({ provider }) {
    let warning = provider.warning && (
        <div className="warning">
            <InfoAlert iconDisplay={false} text={getLiteral(provider.warning)} />
        </div>
    );
    return (
        <div className="provider-detail">
            <div className="content">
                {warning}
                <Text as="div" className="description" type="body">
                    {getLiteral(provider.descriptionLong)}
                </Text>
                <div className="websiteUrl">
                    <Link
                        href={provider.fullWebsite}
                        rel="noreferrer"
                        target="_blank"
                        type="body"
                        variation="primary"
                    >
                        {getLiteral(provider.webSiteLabel)}
                    </Link>
                </div>
            </div>
        </div>
    );
}
